import React, { useContext, useMemo } from 'react';
import { DataContext } from '../../components/DataContext';
import GameSummaryCard from './GameSummaryCard';
import '../../styles/components/_gameCards.css';

export default function GamesList() {
  const { gamesData } = useContext(DataContext);

  const games = useMemo(() => {
    if (!gamesData || typeof gamesData !== 'object') return [];

    return Object.values(gamesData).sort((a, b) => Number(b.gameNumber) - Number(a.gameNumber));
  }, [gamesData]);

  const latestGameNumber = games.reduce(
    (latest, game) => Number(game.gameNumber) > Number(latest) ? game.gameNumber : latest,
    games[0]?.gameNumber
  );
  const biggestPot = games.reduce(
    (biggest, game) => Number(game.moneyOnTable) > Number(biggest?.moneyOnTable) ? game : biggest,
    games[0]
  );

  return (
    <section className="games-list" aria-label="Games by game">
      {games.map((game) => (
        <GameSummaryCard
          game={game}
          isLatest={game.gameNumber === latestGameNumber}
          isBiggestPot={game.gameNumber === biggestPot?.gameNumber}
          key={game.gameNumber}
        />
      ))}
      {!games.length && <p className="games-list-empty">Loading games...</p>}
    </section>
  );
}